import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAwk8LKZccxaqXYriWJLUzfefJ86iOgvvw",
  authDomain: "museshop-7d69f.firebaseapp.com",
  projectId: "museshop-7d69f",
  storageBucket: "museshop-7d69f.appspot.com",
  messagingSenderId: "1062655461523",
  appId: "1:1062655461523:web:6a119faeb848f8aefea566",
  measurementId: "G-K5N855VDF3",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
export const functions = getFunctions(firebaseApp, "europe-west1");

